<template>
  <div class="l-container">
    <!-- Main-content -->
    <div class="main-container">
      <div class="right-container" ref="printableArea">
        <div class="box-right" style="margin: 30px;" id="printableArea">
          <div class="title" style="display:flex; justify-content: space-between;">
            <div style="border-bottom: 1px solid gray; margin-top: 20px;">上原 賢二 様</div>
            <div style="border: 1px solid gray; padding: 2px; margin-top: 20px;">領収書番号：0103869334</div>
          </div>
          <div class="image" style="display:flex; justify-content: flex-end;">
            <img src="@/assets/images/imageStamp.png" />
          </div>
          <h1 
          style="text-align: center;
          font-size: 24px;
          font-weight: 700;">領 収 書</h1>
          <div class="content">
            <span style="font-size: 12px;">このたびはご利用いただき、誠にありがとうございました。</span>
            <p style="font-size: 24px;
            background-color: gray;
            text-align: center;
            border-top: 1px solid #222222;
            border-bottom: 1px solid #222222;">￥１００</p>
            <span style="font-size: 12px;">
              上記金額を正に領収いたしました。<br />
              但し：BSオリジナル企画代金として（クレジットカードご利用分）
            </span>
          </div>

          <!-- Table-detail -->
          <table class="border-collapse border border-green-800" style="width: 100%;">
            <thead>
              <tr>
                <th class="column-1" style="width: 20%; text-align:center; border: 1px solid black;">入金日</th>
                <th class="column-2" style="width: 60%; text-align:center; border: 1px solid black;">商品名</th>
                <th class="column-3" style="width: 20%; text-align:center; border: 1px solid black;">受付番号</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in orderList " :key="`order-list-${index}`">
                <td class="column-1" style="width: 20%; text-align:center; border: 1px solid black;">{{item.time}}</td>
                <td class="column-2" style="width: 60%; text-align:center; border: 1px solid black;">
                  {{item.description}}
                </td>
                <td class="column-3" style="width: 20%; text-align:center; border: 1px solid black;">{{item.phone}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Button-confirmation -->
        <div>
          <div class="button">
            <Button @click="print" :text="'印刷する'" class="button-item" />
          </div>
          <div class="back">
            <i class="icon icon-bor-arrow-left" />
            <p>お申し込み情報詳細に戻る</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/primitive/Button'
import { Printd } from 'printd'

export default {
  components: {
    Button
  },
  data() {
    return {
      d: null,
      breadcrumb_data: [
        'トップ ＞ マイページ ',
        'お申し込み一覧',
        'お申し込み情報詳細',
        '領収書'
      ],
      orderList: [
        {
          time: '2020年04月30日',
          description: '732679コンビニで使えるクーポン【コードタイプ】【先着順】【ローソン】MACHI cafe ドリンク（S)（税込100円）※お持ち帰り限定',
          phone: '0099710066'
        },
        {
          time: '2020年05月30日',
          description: '732679コンビニで使えるクーポン【コードタイプ】【先着順】【ローソン】MACHI cafe ドリンク（S)（税込100円）※お持ち帰り限定',
          phone: '0099710064'
        }
      ]
    }
  },
  mounted() {
    this.d = new Printd()
    const { contentWindow } = this.d.getIFrame()
    
    contentWindow.addEventListener(
      'beforeprint', () => console.log('before print event!')
    )
    contentWindow.addEventListener(
      'afterprint', () => console.log('after print event!')
    )
  },
  methods: {
    print () {
      this.d.print(document.getElementById('printableArea'))
    } 
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
